import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import {
    FreightOptionsApiParameter,
    FreightOptionsResultModel,
    getFreightOptions,
} from "@tSurya/Services/FreightService";

type HandlerType = ApiHandler<
    FreightOptionsApiParameter & HasOnSuccess<FreightOptionsResultModel>,
    FreightOptionsResultModel
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    const result = await getFreightOptions(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.(props.apiResult);
};

export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

const getShipmentOptions = createHandlerChainRunner(chain, "getShipmentOptions");
export default getShipmentOptions;
